import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { AIR_TEMPERATURE_BUTTON } from './air-temperature.button';
import { AIR_TEMPERATURE_LAYER } from './air-temperature.layer';
import { AirTemperatureLegendComponent } from './legend/air-temperature-legend.component';
import { AirTemperatureWidgetComponent } from './widget/air-temperature-widget.component';

export const AIR_TEMPERATURE_PLUGIN = new Plugin({
  id: 'air-temperature',
  button: AIR_TEMPERATURE_BUTTON,
  layer: AIR_TEMPERATURE_LAYER,
  legend: {
    legendComponent: AirTemperatureLegendComponent,
    title: 'AIR TEMPERATURE'
  },
  widget: {
    title: 'Air Temperature',
    pluginIDs: ['air-temperature'],
    widgetComponent: AirTemperatureWidgetComponent
  }
});
